import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { STATUS } from './userDetailslice';
export interface SideMenu {
    index: number ;
    lastUpdated: any;
}
const initialSideMenuSliceState: SideMenu = {
    index: 0,
    lastUpdated: Date.now(), // new
}

const sideMenuSlice = createSlice({
    name: 'SideMenuDetails',
    initialState: initialSideMenuSliceState,
    reducers: {
        updateIndex: (state, action: PayloadAction<number>) => {
            state.index = action.payload;
            state.lastUpdated =  Date.now();
        },
    },
});

export const { updateIndex } = sideMenuSlice.actions;

export default sideMenuSlice.reducer;